import { IAsnContact } from "../serializable/IAsnContact";
import { AsnContact } from "../../asn1/EUCSrv/stubs/ENetUC_Common_AsnContact";
import {
	netDatabaseContactConverter
} from "./netDatabaseContactConverter";
import { absentStateConverter } from "./absentStateConverter";
import { customNoteConverter } from "./customNoteConverter";
import {
	appointmentEntryConverter,
	appointmentEntryListConverter
} from "./appointmentEntryConverter";

/**
 * the contactConverter
 * @param asnContact - an AsnContact
 * @returns an IAsnContact as promise
 */
export async function contactConverter(asnContact: AsnContact): Promise<IAsnContact> {
	let iStaticRights2;
	let bEmergencyLocationDetectionFail;
	/*
	* dieser custom converter ist ja gr...
	* kann man das evtl. per deklaration im Asn generieren lassen like:
	* src\web-shared-components\asn1\EUCSrv\stubs\ENetUC_Auth.ts(297), AsnNegotiateServerConnectionResult
	* src\web-shared-components\asn1\EUCSrv\stubs\ENetUC_Auth_Converter.ts(261), AsnNegotiateServerConnectionV2Result_Converter
	* Caution:
	* das: bEmergencyLocationDetectionFail ist kein allgemeines optional fuer einen: IAsnContact
	* sondern ein special fuer den ownContact im: AsnNegotiateServerConnectionResult
	*/
	if (asnContact.optionalParams) {
		for (const [key, value] of Object.entries(asnContact.optionalParams)) {
			if (key === "iStaticRights2" && typeof value === "number")
				iStaticRights2 = value;
			if (key === "bEmergencyLocationDetectionFail" && typeof value === "number")
				bEmergencyLocationDetectionFail = value;
		}
	}
	return {
		u8sContactId: asnContact.u8sContactId,
		iContactFeatureSet: asnContact.iContactFeatureSet,
		iPresenceState: asnContact.iPresenceState,
		iStaticRights: asnContact.iStaticRights,
		iMonitorAccessRights: asnContact.iMonitorAccessRights,
		asnRemoteContact: await netDatabaseContactConverter(asnContact.asnRemoteContact),
		seqPhoneLines: asnContact.seqPhoneLines,
		asnAbsentState: absentStateConverter(asnContact.asnAbsentState),
		asnCustomNote: customNoteConverter(asnContact.asnCustomNote),
		seqActualAppointments: appointmentEntryListConverter(asnContact.seqActualAppointments),
		asnNextAppointment: appointmentEntryConverter(asnContact.asnNextAppointment),
		asnUserPropertyBag: asnContact.asnUserPropertyBag,
		iStaticRights2,
		bEmergencyLocationDetectionFail
	};
}
